/***************************************************************************/
"use client";
/***************************************************************************/

import { VariantProps, cva } from "class-variance-authority";
import * as React from "react";
import { cn } from "../../../utils/css";

const flexItemVariants = cva("", {
  variants: {
    justify: {
      auto: "justify-self-auto",
      start: "justify-self-start",
      end: "justify-self-end",
      center: "justify-self-center",
      stretch: "justify-self-stretch",
    },
    "justify-sm": {
      auto: "sm:justify-self-auto",
      start: "sm:justify-self-start",
      end: "sm:justify-self-end",
      center: "sm:justify-self-center",
      stretch: "sm:justify-self-stretch",
    },
    "justify-md": {
      auto: "md:justify-self-auto",
      start: "md:justify-self-start",
      end: "md:justify-self-end",
      center: "md:justify-self-center",
      stretch: "md:justify-self-stretch",
    },
    "justify-lg": {
      auto: "lg:justify-self-auto",
      start: "lg:justify-self-start",
      end: "lg:justify-self-end",
      center: "lg:justify-self-center",
      stretch: "lg:justify-self-stretch",
    },
    "justify-xl": {
      auto: "xl:justify-self-auto",
      start: "xl:justify-self-start",
      end: "xl:justify-self-end",
      center: "xl:justify-self-center",
      stretch: "xl:justify-self-stretch",
    },
    align: {
      auto: "self-auto",
      start: "self-start",
      end: "self-end",
      center: "self-center",
      stretch: "self-stretch",
    },
    "align-sm": {
      auto: "sm:self-auto",
      start: "sm:self-start",
      end: "sm:self-end",
      center: "sm:self-center",
      stretch: "sm:self-stretch",
    },
    "align-md": {
      auto: "md:self-auto",
      start: "md:self-start",
      end: "md:self-end",
      center: "md:self-center",
      stretch: "md:self-stretch",
    },
    "align-lg": {
      auto: "lg:self-auto",
      start: "lg:self-start",
      end: "lg:self-end",
      center: "lg:self-center",
      stretch: "lg:self-stretch",
    },
    "align-xl": {
      auto: "xl:self-auto",
      start: "xl:self-start",
      end: "xl:self-end",
      center: "xl:self-center",
      stretch: "xl:self-stretch",
    },
    flex: {
      auto: "flex-auto",
      initial: "flex-initial",
      none: "flex-none",
      1: "flex-1",
      2: "flex-2",
      3: "flex-3",
      4: "flex-4",
      5: "flex-5",
      6: "flex-6",
      7: "flex-7",
      8: "flex-8",
      9: "flex-9",
      10: "flex-10",
    },
  },
});

const FlexItem: React.FC<
  React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof flexItemVariants>
> = ({
  className,
  justify,
  "justify-sm": justifySM,
  "justify-md": justifyMD,
  "justify-lg": justifyLG,
  "justify-xl": justifyXL,
  align,
  "align-sm": alignSM,
  "align-md": alignMD,
  "align-lg": alignLG,
  "align-xl": alignXL,
  flex,
  ...props
}) => {
  return (
    <div
      className={cn(
        flexItemVariants({
          justify,
          "justify-sm": justifySM,
          "justify-md": justifyMD,
          "justify-lg": justifyLG,
          "justify-xl": justifyXL,
          align,
          "align-sm": alignSM,
          "align-md": alignMD,
          "align-lg": alignLG,
          "align-xl": alignXL,
          flex,
        }),
        className,
      )}
      {...props}
    />
  );
};

export { FlexItem, flexItemVariants };
